import { X } from 'lucide-react'
import { FilterSectionSingleProps } from '../types'

const CHIP_STYLE = { backgroundColor: '#F5F5F5' }

export function FilterSectionSingle({ label, value, onRemove }: FilterSectionSingleProps) {
  return (
    <>
      <div className="h-4 w-px bg-gray-300 flex-shrink-0" />
      <span className="text-xs text-gray-600 whitespace-nowrap">{label}:</span>
      <div
        className="flex items-center gap-1 rounded-full px-3 py-1 flex-shrink-0"
        style={CHIP_STYLE}
      >
        <span className="text-xs font-semibold text-gray-900">{value}</span>
        <button
          type="button"
          onClick={onRemove}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Remover filtro"
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </>
  )
}
